import { LeadMediaplanDto, UpdateLeadMediaplanDto, DownloadFileDto } from '@sr/dto';
import { fromNullableNumberField, toNullableNumberField } from 'utils/form-helper';
import { formatDateTime } from 'utils/date-format-helpers';
import { formatPerson } from 'utils/person-format-helpers';

export type FormValues = {
  cityId: number | '';
  mediaTypeId: number | '';
  offerFile: DownloadFileDto[];
  mediaplanSum: number | '';
  createdBy: string;
  createdAt: string;
};

export const toDto = (values: FormValues): UpdateLeadMediaplanDto => ({
  offerFile: values.offerFile.length > 0 ? values.offerFile[0] : null,
  cityId: toNullableNumberField(values.cityId),
  mediaTypeId: toNullableNumberField(values.mediaTypeId),
  mediaplanSum: toNullableNumberField(values.mediaplanSum),
});

export const fromDto = (dto: LeadMediaplanDto): FormValues => ({
  cityId: fromNullableNumberField(dto.cityId),
  mediaTypeId: fromNullableNumberField(dto.mediaTypeId),
  mediaplanSum: dto.mediaplanSum ?? '',
  offerFile: dto.offerFile ? [dto.offerFile] : [],
  createdBy: dto.createdBy ? formatPerson(dto.createdBy) : '',
  createdAt: formatDateTime(dto.createdAt)
});

export const initialValues = (): FormValues => ({
  cityId: '',
  mediaTypeId: '',
  mediaplanSum: '',
  offerFile: [],
  createdBy: '',
  createdAt: ''
});
